import { create } from 'zustand';
import type { KPIConsecutiveFailScanResponse } from '@/types/kpi-consecutive-fail';
import { emptyKPIConsecutiveFailScanResponse } from '@/types/kpi-consecutive-fail';

type KPIConsecutiveFailState = {
  departmentId: string;
  year: number;
  data: KPIConsecutiveFailScanResponse;
  loading: boolean;
  syncedAt: number;
  setLoading: (loading: boolean) => void;
  setFromScan: (departmentId: string, year: number, payload: KPIConsecutiveFailScanResponse) => void;
  clear: () => void;
};

function normalizePayload(payload: unknown): KPIConsecutiveFailScanResponse {
  const p = (payload || {}) as Partial<KPIConsecutiveFailScanResponse>;
  return {
    idBoPhan: p.idBoPhan ?? '',
    year: p.year ?? new Date().getFullYear(),
    threshold: p.threshold ?? 3,
    enabled: p.enabled ?? true,
    self: Array.isArray(p.self) ? p.self : [],
    employees: Array.isArray(p.employees) ? p.employees : [],
    childDepts: Array.isArray(p.childDepts) ? p.childDepts : [],
    totalCount: Number(p.totalCount ?? p.activeCount ?? 0),
    activeCount: Number(p.activeCount ?? p.totalCount ?? 0),
  };
}

export const useKPIConsecutiveFailStore = create<KPIConsecutiveFailState>((set) => ({
  departmentId: '',
  year: new Date().getFullYear(),
  data: emptyKPIConsecutiveFailScanResponse(),
  loading: false,
  syncedAt: 0,

  setLoading: (loading) => set({ loading }),

  setFromScan: (departmentId, year, payload) =>
    set({
      departmentId,
      year,
      data: normalizePayload(payload),
      loading: false,
      syncedAt: Date.now(),
    }),

  clear: () =>
    set({
      departmentId: '',
      year: new Date().getFullYear(),
      data: emptyKPIConsecutiveFailScanResponse(),
      loading: false,
      syncedAt: 0,
    }),
}));
